import { Provider } from '@angular/core';
import { UserRepositoryPort } from '../domain/repositories/user.repository.port';
import { UserRepository } from './repositories/user.repository';

export const USER_PROVIDERS: Provider[] = [
  {
    provide: UserRepositoryPort,
    useClass: UserRepository,
  },
];
